import { LevelData } from '../level-data';

export const level8: LevelData = {
    name: 'Zigzag',
    timeLimit: 85,
    track: [
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-----  ',
        '-------',
        '-------',
        '-------',
        '  -----',
        '-------',
        '-------',
        '-------',
        '-----  ',
        '-------',
        '-------',
        '---B---',
        '-------',
        '  -----',
        '-------',
        '-------',
        '-------',
        '-----  ',
        '-------',
        '-------',
        '-------',
        '  -----',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
